module.exports = ".subs-faq-text {\n    line-height: 1.67;\n    color: #0d1a31;\n    font-family: Montserrat-Regular;\n    font-size: 13px;\n  }\n  input[type=number]::-webkit-inner-spin-button, \n  input[type=number]::-webkit-outer-spin-button { \n  -webkit-appearance: none; \n  margin: 0; \n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/feature/main/roles-shared/components/purchase-tokens/purchase-tokens.component.css
// module id = ./src/app/feature/main/roles-shared/components/purchase-tokens/purchase-tokens.component.css
// module chunks = main